import {Component, Vue} from 'vue-facing-decorator';
import { ref } from "vue";
import ax from '@/utils/axios';
import Loading from 'vue-loading-overlay';
import PDF from "pdf-vue3";

import YTComp from '@/components/YTComp/YTComp.vue';
import HeaderCard from '@/components/HeaderCard/HeaderCard.vue';

@Component({
    name: 'about-view',
    components: {       
        'loading'    : Loading,
        "p-pdf" : PDF,
        "header-card" : HeaderCard,
        'p-yt'  : YTComp
    }
})
export default class AboutView extends Vue{
    showGif= true
    is_loading          = false;
    data : any          = ref();

    mounted() {
        this.getData();
        setTimeout(() => {
          this.showGif = false;
        }, 2000); // Tampilkan GIF selama 5 detik
    }

    unmounted(){
        this.data = []
    }


    //------------------------------------------------
    categorizeFiles(data:any) {
        if (data && data.file) {
          const files = data.file.split(" "); // Pisahkan teks berdasarkan spasi
          const pdfRegex = /\.pdf$/i; // Regex untuk PDF
          const imageRegex = /\.(png|jpe?g)$/i; // Regex untuk gambar (png, jpg, jpeg)
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (pdfRegex.test(file)) {
              return "pdf";
            } else if (imageRegex.test(file)) {
              return "image";
            }
          }
      
          return null;
        }
        return null; // Kembalikan array kosong jika data tidak valid
    }
    //------------------------------------------------


 

    async getData(){
        this.is_loading = true;
        //--------------------------------------------
 
        await ax.get("konten/list", {
            params:{s_jenis : "PROFIL",}
        }).then( (res : any) => {
            if(res.data.status){
                this.data       = res.data.data.data;
                //console.log(this.data)
            }
            //console.log(res.data.data.to_show)
            this.is_loading = false;
        }).catch((err : any) => {
            console.log(err)
            if(err.response){
                this.$toast.add({ severity: 'warn',  summary: 'Error!!', detail: err.response.data.message, life: 3000 });
            }
            this.is_loading = false;
        })
        //--------------------------------------------
    }
    //------------------------------------------------

    
}